import options from './chart-differential-pressure.component';

export default {
    selector: 'dtChartDifferentialPressure',
    options
};
